export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const TCDWCL_QUALIFICATION_DETAILS = 'tcdwcl-qualification-details';
export const TCDWCL_EMPLOYMENT_DETAILS = 'tcdwcl-employment-details';

export const TCDWCL_APPLICATION = [
    {
        sectionID: TCDWCL_QUALIFICATION_DETAILS,
        sectionName: 'Qualification Details',
        fieldList: [
            {
                id: 'tcdwcl-qualification-details',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'certificate-type',
                        header: 'Certificate Type',
                        type: 'text'
                    },
                    {
                        id: 'course-name',
                        header: 'Course Name',
                        type: 'text'
                    },
                    {
                        id: 'certificate-name',
                        header: 'Certificate Name',
                        type: 'text'
                    },
                    {
                        id: 'date-passed',
                        header: 'Date Passed',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: TCDWCL_EMPLOYMENT_DETAILS,
        sectionName: 'Employment Details',
        fieldList: [
            {
                id: 'self-employed',
                label: 'Self Employed',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'qualification',
                label: 'Qualification',
                type: 'text',
                span: 12
            },
            {
                id: 'practical-experience',
                label: 'Practical Experience',
                type: 'text',
                span: 12
            },
            {
                id: 'certification',
                label: 'Certification',
                type: 'text',
                span: 12
            },
            {
                id: 'work-permit',
                label: 'Work Permit (Optional)',
                type: 'text',
                span: 12
            },
            {
                id: 'particulars-of-employer',
                label: 'Particulars Of Employer',
                type: 'text',
                span: 12
            },
            {
                id: 'cpf-info',
                label: 'CPF Info',
                type: 'text',
                span: 12
            },
        ]
    }
];
